import { I18N_NAMESPACES } from "@src/appV2/i18n/constants";
import { useTu } from "@src/appV2/i18n/useTu";

import { SETTINGS_SECTIONS, type SettingsSectionConfig } from "../types";

export function useSettingsSectionConfigs(): SettingsSectionConfig[] {
  const { tu } = useTu(I18N_NAMESPACES.settings);

  return [
    {
      id: SETTINGS_SECTIONS.timeAndAttendance,
      title: tu("Time & Attendance"),
      description: tu(
        "Configure clock-in restrictions, break policies, and attendance verification."
      ),
    },
    {
      id: SETTINGS_SECTIONS.workerCredentials,
      title: tu("Worker Credentials"),
      description: tu(
        "Configure worker credentials for charting and timekeeping, and configure the onboarding view."
      ),
    },
    {
      id: SETTINGS_SECTIONS.scheduling,
      title: tu("Scheduling"),
      description: tu("Manage booking modes and shift hour limits."),
    },
    {
      id: SETTINGS_SECTIONS.compliance,
      title: tu("Compliance & Documentation"),
      description: tu("Set badge requirements, sign-out methods, and charting compliance."),
    },
    {
      id: SETTINGS_SECTIONS.rateAndBilling,
      title: tu("Rate & Billing"),
      description: tu("Control rate negotiation and billing integrations."),
    },
    {
      id: SETTINGS_SECTIONS.jobManagement,
      title: tu("Job Management"),
      description: tu("Manage job settings for child facilities."),
    },
    {
      id: SETTINGS_SECTIONS.calendarDisplay,
      title: tu("Calendar Display"),
      description: tu("Configure worker type visibility and ordering on the calendar."),
    },
    {
      id: SETTINGS_SECTIONS.translation,
      title: tu("Language"),
      description: tu("Choose your preferred language for the redesigned pages."),
    },
    {
      id: SETTINGS_SECTIONS.appInfo,
      title: tu("About"),
      description: tu("App version and update information."),
    },
  ];
}
